import { useAxiosStore } from '@risksmart-app/components/src/hooks/useAxios';
import { isAxiosError } from 'axios';
import { useCallback } from 'react';

export const useCustomOrgLogo = () => {
  const { authorisedAxiosInstance } = useAxiosStore();

  return useCallback(async (): Promise<string | null> => {
    try {
      const response = await authorisedAxiosInstance.get('/logo', {
        responseType: 'blob',
        // 404 is an expected signal from the backend meaning "no custom logo";
        // opting it in here bypasses the global Sentry interceptor for this case.
        validateStatus: (status) => status === 200 || status === 404,
      });

      if (response.status === 404) {
        return null;
      }

      const blob = new Blob([response.data], { type: 'image/jpeg' });

      return URL.createObjectURL(blob) || null;
    } catch (e) {
      if (isAxiosError(e) && e.response?.status === 404) {
        return null;
      }
      throw e;
    }
  }, [authorisedAxiosInstance]);
};
